import React from 'react'
import { Icon } from '@chakra-ui/react'
import { gql, useMutation } from '@apollo/client'
import { FaArrowsRotate } from 'react-icons/fa6'

import SharedButton from '~components/shared/buttons/shared-button'
import { useClinic } from '~contexts/clinic-context'
import { useToastFeedback } from '~utils/hooks/use-toast-feedback'
import { isCloudPMS } from '~utils/pms-helpers'
import {
    ClientFieldsFragmentDoc,
    namedOperations,
} from '~graphql/generated/graphql'

const SYNC_INDIVIDUAL_CLIENT = gql`
    mutation syncIndividualClient($clientId: ID!, $clinicId: ID!) {
        syncIndividualClient(clientId: $clientId, clinicId: $clinicId) {
            ...ClientFields
        }
    }
    ${ClientFieldsFragmentDoc}
`

interface Props {
    client: {
        id: string
        pms_id?: string | null
    }
}

export default function SyncIndividualClientButton({ client }: Props) {
    const { clinic } = useClinic()
    const { onCompleted, onError } = useToastFeedback(
        'Client synced from PIMS.',
        'Failed to sync client from PIMS.',
    )

    const [syncClient, { loading }] = useMutation(SYNC_INDIVIDUAL_CLIENT, {
        onCompleted,
        onError,
        refetchQueries: [namedOperations.Query.getClient],
        awaitRefetchQueries: true,
    })

    if (!clinic?.id || !client.pms_id || !isCloudPMS(clinic.pms)) {
        return null
    }

    return (
        <SharedButton
            size="sm"
            variant="outline"
            leftIcon={<Icon as={FaArrowsRotate} />}
            isLoading={loading}
            onClick={() =>
                syncClient({
                    variables: {
                        clientId: client.id,
                        clinicId: clinic.id,
                    },
                })
            }
        >
            Sync from PIMS
        </SharedButton>
    )
}
